import React, { useEffect, useRef, Component } from "react";
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../assets/img/svg/save.svg';
import Cancel from '../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../assets/img/svg/delete.svg';
import docIcon from '../../../../assets/img/svg/docIcon.svg';
import {
    TextField, FormControlLabel, Radio, Checkbox, Grid,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup, FormGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Autocomplete from "react-autocomplete";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import { pbdlookupdescription, geteditpbddocinfo, filedeletepbd } from "../../../../actions/PBDAction";
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import del from "../../../../assets/img/svg/Del.svg"
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

class EditPBD_Detail extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            ProjectId: 0,
            Docs: [],
            filename: "",
            awsname: "",
            Id: 0,
            DelIndex: 0,
            isMobile: false,
            isError: false,
            Error: {
                "DescriptionError": false,
               
                "DateError": false,
            },
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Description": "",
               
                "Date": "",
                "Comments": ""
            }
        }
    }

    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    setCheckbox = (index) => {
        this.state.Docs.map((i, ind) => {
            if (ind == index) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };

    componentDidMount() {
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("PBDEditId"))
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.props.dispatch(pbdlookupdescription())
        this.props.dispatch(getlookupdocinfo("PreBeaching"))
        this.geteditpbddocinfo(this.state.addData.Id)
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    };

    geteditpbddocinfo = (id) => {
        let apiUrl = API.PBD_LISTVIEW + '/' + id
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "PBDEDIT_DOCS", data: response.data });
                    this.state.addData.Id = response.data.Id;
                    this.state.addData.Description = response.data.Description;
                    this.state.addData.Date = response.data?.Date;
                    // if (response.data.Description == "others") {
                    //     this.state.others = true;
                    //     this.setState({})
                    // }
                    // this.state.addData.Others = response.data?.others;
                    if (response.data?.Attachements.length > 0) {
                        response.data?.Attachements.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.Docs = response.data?.Attachements;
                    }
                    let Error = {
                        "DescriptionError": false,
                       
                        "DateError": false,
                    }
                    this.state.Error = Error;
                    this.setState({})
                    this.props.dispatch({ type: "ERROR_PBDFILES", data: this.state.Error })
                    //this.props.dispatch({ type: "PASS_PBDOTHERS", data: this.state.others })
                    this.props.dispatch({ type: "SHARE_PBDFILES", data: this.state.addData })
                    this.props.dispatch({ type: "SHARE_PBDDATAS", data: this.state.Docs })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#Prebeaching1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Prebeaching").addClass("d-none");
        $("#Prebeaching").removeClass("d-block");
        $("#PBDL").removeClass("active-color");
        $("#PBDT").removeClass("fw-bolder");
    };

    AddCancel = () => {
        this.props.navigate("/prebeachingdocuments")
    };

    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };

    handleProjectNameSearchChange = (e) => {
        this.state.addData.Description = e.target.value;
        this.setState({});
        // if (this.state.addData.Description == 'others') {
        //     this.state.others = true;
        //     this.setState({});
        // }
        // else {
        //     this.state.others = false;
        //     this.setState({});
        // }
        // this.props.dispatch({ type: "PASS_PBDOTHERS", data: this.state.others })
        this.props.dispatch({ type: "SHARE_PBDFILES", data: this.state.addData })
    };

    handleProjectNameSelectChange = (e) => {
        this.state.addData.Description = e;
        this.setState({});
        // if (this.state.addData.Description == 'others') {
        //     this.state.others = true;
        //     this.setState({});
        // }
        // else {
        //     this.state.others = false;
        //     this.setState({});
        // }
        // this.props.dispatch({ type: "PASS_PBDOTHERS", data: this.state.others })
        this.props.dispatch({ type: "SHARE_PBDFILES", data: this.state.addData })
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    };

    DeleteItem = () => {
        let tempData = [];
        this.state.Docs.map((i, index) => {
            if (this.state.DelIndex == index) {
                if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                    this.props.dispatch(filedeletepbd(this.state.addData.Id, this.state.awsname))
                }
            }
            if (this.state.DelIndex != index) {
                tempData.push(i)
            }
        })
        this.state.Docs = tempData;
        this.setState({})
        window.$("#deletepopup").modal("hide");
    }

    UploadFile = (e) => {
      
        Array.from(e.target.files).forEach(async (a) => {
            let upload = {
                FileName: a.name,
                FileSize: a.size,
                check: false,
                fdata: a,
            }
            this.state.Docs.push(upload)
            this.setState({})
        })
        this.props.dispatch({ type: "SHARE_PBDDATAS", data: this.state.Docs })
    };

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#Prebeaching1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Prebeaching").removeClass("d-none");
        $("#Prebeaching").addClass("d-block");
        $("#PBDL").addClass("active-color");
        $("#PBDT").addClass("fw-bolder");
    };

    OpenPopup = (filename, awsname, id, index) => {
        this.state.filename = filename;
        this.state.awsname = awsname;
        // this.state.Id = id;
        this.state.DelIndex = index;
        this.setState({})
        window.$("#deletepopup").modal("show");
    }

    handleInputChange = (e, str) => {
        this.state.addData[str] = e.target.value;
        this.setState({})
        // this.props.dispatch({ type: "PBDEDIT_DOCS", data: this.state.addData })
        this.props.dispatch({ type: "SHARE_PBDFILES", data: this.state.addData })
    };

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                <div style={{ margin: this.state.isMobile ? "0" : "15px 30px" }}>
                    <div className="row mt-1">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                            <label>Description :</label>
                        </div>
                        <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4">
                            <div className="autocomplete-wrappers">
                                {this.props.errorpbdpass.DescriptionError ? <>
                                    <Autocomplete
                                        contentEditable={true}
                                        value={this.state.addData.Description}
                                        inputProps={{
                                            placeholder: "Description",
                                        }}
                                        items={this.props.PBDDESC_LOOKUP ?? []}
                                        getItemValue={(item) => item.Name}
                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                        renderMenu={(item) => (
                                            <div className="dropdowns d-block" >{item}</div>
                                        )}
                                        renderInput={(props) => {
                                            return (
                                                <input
                                                    className="form-control border-radius"
                                                    id="exampleFormControlInput1"
                                                    {...props}
                                                    fullWidth
                                                    style={{ width: '100%', height: 35, fontSize: 12, color: "#000000", borderColor: 'red' }}
                                                />
                                            );
                                        }}
                                        renderItem={(item, isHighlighted) => (
                                            <div
                                                className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                    }`}
                                            >
                                                {item.Name}
                                            </div>
                                        )}
                                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                    />
                                    <div className="helperText pt-1">
                                        <p style={{ color: 'red' }}> Required field must be filled in</p>
                                    </div></>
                                    :
                                    <Autocomplete
                                        contentEditable={true}
                                        value={this.state.addData.Description}
                                        inputProps={{
                                            placeholder: "Description",
                                        }}
                                        items={this.props.PBDDESC_LOOKUP ?? []}
                                        getItemValue={(item) => item.Name}
                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                        renderMenu={(item) => (
                                            <div className="dropdowns d-block" >{item}</div>
                                        )}
                                        renderInput={(props) => {
                                            return (
                                                <input
                                                    className="form-control border-radius"
                                                    id="exampleFormControlInput1"
                                                    {...props}
                                                    // fullWidth
                                                    style={{ width: '100%', height: 35, fontSize: 12, color: "#000000" }}
                                                // style={{ width: this.state.isMobile ? 100 : 223, height: 32, fontSize: 12, color: "#000000" }}
                                                />
                                            );
                                        }}
                                        renderItem={(item, isHighlighted) => (
                                            <div
                                                className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                    }`}
                                            >
                                                {item.Name}
                                            </div>
                                        )}
                                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                    />}
                            </div>
                        </div>
                        {/* {this.state.others == true ? <>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 mt-2">
                                <label>others :</label>
                            </div>
                            <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4 mt-2">
                                {this.props.errorpbdpass.OthersError ?
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        error
                                        value={this.state.addData.Others}
                                        onChange={(e) => this.handleInputChange(e, "Others")}
                                        helperText="Required field must be filled in"
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                        classes={{ root: classes.helperText }}
                                    />
                                    :
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Others}
                                        onChange={(e) => this.handleInputChange(e, "Others")}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                }
                            </div></> : <></>} */}
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                            <label>Date :</label>
                        </div>
                        <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4">
                            {this.props.errorpbdpass.DateError ?
                                <TextField
                                    type="date"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    error
                                    value={moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                    onChange={(e) => { this.handleInputChange(e, "Date") }}
                                    helperText="Required field must be filled in"
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                    classes={{ root: classes.helperText }}
                                />
                                :
                                <TextField
                                    type="date"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                    onChange={(e) => { this.handleInputChange(e, "Date") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                            }
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                            <label>Attachments :</label>
                        </div>
                        <div className="col-12 col-sm-12 pb-4 col-md-12 col-lg-4 col-xl-4">
                            <TextField
                                disabled
                                variant="outlined"
                                size="small"
                                fullWidth
                                accept=".pdf"
                                placeholder="Browse File"
                                onChange={(e) => this.UploadFile(e)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment className="mr-0">
                                            <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                <AttachFileIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    className: `border-radius ${classes.inputfieldAlign}`
                                }}
                            />
                            <input
                                hidden
                                onChange={(e) => this.UploadFile(e)}
                                accept=".pdf"
                                type="file"
                                ref={this.inputFile}
                            />
                            {this.state.Docs && this.state.Docs.map((m, i) => (
                                <div className="row pt-3">
                                    <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1">
                                        <label class="contCheck">
                                            <input type="checkbox" checked={m.check} onChange={() => this.setCheckbox(i)} ></input>
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1">
                                        <img src={docIcon} />
                                    </div>
                                    <div className="col-9 col-sm-9 col-lg-9 col-xl-9 col-md-9 pl-4" >
                                        <label className="fw-700">{m.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(m.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                    </div>
                                    {m.check == true ?
                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pt-1 pt-2 pl-0 pr-0 mr-0 space">
                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(m.FileName, m.AwsUniqueFileName, m.Id, i) }} />
                                        </div> : <></>}
                                </div>
                            ))}
                        </div>
                        <div className="row pr-0 mr-0">
                            <div className="col-12 mt-3 col-sm-12 col-md-12 col-lg-2 col-xl-2">
                                <label>Comments :</label>
                            </div>
                            <div className="col-12 mt-3 col-sm-12 pb-4 col-md-12 col-lg-10 col-xl-10 pr-0 mr-0">
                                <TextField
                                    multiline
                                    rows={8}
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={this.state.addData.Comments}
                                    onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                <button type="button" id="closemodal1" onClick={() => { window.$("#deletepopup").modal("hide") }} class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        PBDDESC_LOOKUP: state.MasterDataReducer.Lookup_data || [],
        geteditpbd: state.PBDReducer.geteditpbd || [],
        errorpbdpass: state.PBDReducer.errorpbdpass || [],
        sharedpbdfile: state.PBDReducer.sharedpbdfile || [],
        sharedpbddata: state.PBDReducer.sharedpbddata || [],
    };
}

EditPBD_Detail.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditPBD_Detail))
);